<button *ngIf="form && checkComponent()" matTooltip="Modifica Stato" type="button"
 class="my-bounce btn styleButton mx-2 clsButtonDefault" (click)="openModal()">
 {{ 'CHANGESTATEBUTTON.migrate_state_title' | translate }}
</button>